import React, { useEffect } from "react";
import { useState } from "react";

// This import ensures that monaco-editor-webpack plugin will work (see here: https://www.npmjs.com/package/monaco-editor-webpack-plugin)
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import Editor, { loader, useMonaco, Monaco } from "@monaco-editor/react";
import './MonacoEditor.css';

// When hosted locally, the files will be linked to the vention_rails project,
// however they will be loaded to aws when in production.
declare const __MONACO_FILES_PATH__: string;
window.MonacoEnvironment = {
  /* global __MONACO_WORKER__ */
  baseUrl: __MONACO_FILES_PATH__
};

// Specifies that the Editor's loader should load from our local Monaco (otherwise it targets a CDN).
loader.config({ monaco: monaco });

interface MonacoEditorProps {
  source: string;
  filename: string;
  onChange: ((filename: string, value: string | undefined) => void) | undefined;
  playing?: boolean;
  className?: string;
  language?: 'javascript' | 'python';
  theme?: string;
  onMonacoAvailable?: (monaco: Monaco) => void;
}


export function MonacoEditor({source, filename, onChange, playing = false, className = '', language = 'javascript', theme = "vs", onMonacoAvailable}: MonacoEditorProps) {
  const [minimap, setMinimap] = useState(true);
  const monacoInstance = useMonaco();

  function handleEditorChange(value: string | undefined) {
    onChange && onChange(filename, value);
  }

  useEffect(() => {
    if (monacoInstance && onMonacoAvailable) {
      onMonacoAvailable(monacoInstance);
    }
  }, [ monacoInstance ]);

  // NOTE: for some reason adding any other component next to the Editor will cause it to grow continuously
  return (
    <div className={'vention-monaco-editor ' + className}>
      <Editor
        defaultLanguage={language}
        value={source}
        theme={theme}
        onChange={handleEditorChange}
        className={playing ? ' monaco-editor-disabled' : ''}
        // options can be found here:  https://blutorange.github.io/primefaces-monaco/typedoc/interfaces/monaco.editor.istandaloneeditorconstructionoptions.html
        options={{
          readOnly: playing,
          lineNumbers: 'on',
          minimap: {
            enabled: minimap
          },
          // allow completion from words within the file
          wordBasedSuggestions: true,
          suggestOnTriggerCharacters: true,
          acceptSuggestionOnEnter: "on",
          tabCompletion: "on",
          quickSuggestions: {
            other: true,
            comments: true,
            strings: true
          },
          quickSuggestionsDelay: 100,
        }}
      />
    </div>
  );
}
